import { shade } from 'polished';
import styled, { keyframes } from 'styled-components';
import Tooltip from '../../../../components/Tooltip';
import { Content } from '../../layout/AdminToolContent/styles';

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateZ(-100px)

  }
  to {
    opacity: 1;
    transform: translateZ(0px)

  }
`;

export const Container = styled.div`
  overflow: auto;
  @media (max-width: 768px) {
    height: 800px;
    padding-bottom: 2rem;
  }
  @media (min-width: 1385px) {
    display: flex;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 20px;
  animation: ${appear} 0.7s;
  padding: 10px 0px;
  overflow: auto;

  & div.close {
    display: flex;
    height: 30px;
    width: 100%;
    margin-top: 0px;
    margin-left: 0;
    animation: ${appear} 0.7s;

    & button {
      background-color: transparent;
      display: flex;
    }

    & svg {
      color: #888888;
    }

    & p {
      color: #888888;
      font-size: 18px;
      font-weight: 500;
    }
  }
 
}
`;

export const RoleForm = styled.div`
  background-color: #ececec;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 1500px;
  margin: 10px;
  padding: 10px;
  border-radius: 15px;
  box-shadow: -5px 5px 5px ${shade(0.2, '#ececec')};
  gap: 20px;
  animation: ${appear} 0.7s;
  zoom: 0.79;

  & form {
    box-shadow: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    gap: 30px;
    padding-top: 50px;
    padding-bottom: 20px;

    & div.form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      & div.input {
        gap: 20px;
        min-width: 300px;
        width: 100%;

        & p {
          font-size: 16px;
          color: #000000;
          font-weight: 500;
        }

        & div.input {
          & div.container-input {
            background-color: #ffffff;
          }
        }

        & div.disabled {
          border: none;
          div {
            background: #ececec;
            border: 2px solid #ececec;
            cursor: not-allowed;
            input {
              color: #b9b9b9;
              cursor: not-allowed;
            }
          }
        }
      }

      & select {
        height: 26px;
        padding: 5px 10px;
      }

      & button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        width: 200px;
        margin-top: 20px;
      }
      
      & h2 {margin: 20px;}
    }

  @media (max-width: 1300px) {
    width: 65%;
  }

  @media (max-width: 1023px) {
    width: 70%;
    padding: 30px 10px 30px 45px;
    box-shadow: -8px 0px 10px 0px #e0e0e0;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 5px;
    box-shadow: none;
    padding-bottom: 65px;

    & form {
      border-radius: 10px;
      padding: 15px;
      & > h2 {
        margin: 7px 0;
        font-size: 1em;
      }

      & p {
        margin: 0 0 5px 0;
      }

      & button {
        margin-top: 15px;
      }
    }
  }
`;



export const Register = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;

  & button.register {
    background-color: #09495d;
    color: #ffffff;
    display: flex;
    width: 150px;
    height: 37.5px;
    text-transform: uppercase;
    border-radius: 10px;
    font-size: 0.8rem;
    font-weight: 500;
    justify-content: space-around;
    align-items: center;
    padding: 0 15px;
    &:hover {
      background: ${shade(0.2, '#09495d')};
    }
  }

  @media (max-width: 1240px) {
    & button.register {
      scale: 0.8;
    }
  }
`;

export const SearchResults = styled(Content)`
  width: 100%;
  animation: ${appear} 0.6s;
  zoom: 0.85;
  & > div.results {
    > h3 {
      font-size: 1rem;
    }

    h3.result {
      color: #afafaf;
      margin-top: 10px;
    }

    & ul {
      width: 100%;
      overflow: auto;
      max-height: 450px;
      & button {
        background-color: #f6f6f6;
        border-radius: 10px;
        width: 95%;
        height: 62px;
        padding: 0 20px;
        & p {
          font-weight: 400;
          width: 40%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        & span {
          & svg {
            font-size: 2em;
            color: #000000;
            &:hover {
              color: ${shade(0.3, '#666666')};
              cursor: pointer;
            }
          }
        }
        & span.confirm {
          & svg {
            color: #fa0000;
            &:hover {
              color: #fa0000;
              cursor: pointer;
            }
          }
        }

        &:hover {
          font-weight: 300;
          cursor: default;
        }
      }

      ::-webkit-scrollbar {
        width: 15px;
      }
      ::-webkit-scrollbar-track {
        background: #ececec;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${shade(0.3, '#ececec')};
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    order: 1;
    margin-top: 0;
    margin-bottom: 70px;
  }
`;
export const SearchForm = styled(Content)`
  width: 400px;
  animation: ${appear} 0.6s;

  & form.search {
    width: 250px;
  }

  & select {
    height: 26px;
    padding: 5px 10px;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 0;
    margin-bottom: 70px;

    & form.search {
      width: 100%;
    }
  }
`;

export const PermissionError = styled(Tooltip)`
  display: flex;
  position: relative;
  background-color: transparent;
  height: 40px;
  align-items: center;
  max-width: 40px;
  padding-left: 0px;

  svg {
    margin: 0;
  }

  span {
    border: none;
    background: #c53030;
    color: #fff;
    margin-left: 10px;

    &::before {
      border-color: none;
    }
  }
`;

/* App.css */
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Três colunas de largura igual */
  gap: 10px; /* Espaçamento entre os itens */

`;

export const DeleteModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-content {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 90%;
    text-align: center;

    h3 {
      margin: 0 0 1rem 0;
      color: #333;
      font-size: 1.25rem;
    }

    p {
      margin: 0.5rem 0;
      color: #666;
      line-height: 1.5;

      &.warning {
        color: #dc3545;
        font-weight: bold;
      }
    }

    .modal-buttons {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: 1.5rem;
    }
  }
`;